// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"ff47c696","publicCreateRecord":"c33a9677","choiceSection":"da5d9a41","choice":"d93e4d53","selected":"e10d832c"};